import { render, staticRenderFns } from "./editTabulations.vue?vue&type=template&id=639cb7b0&scoped=true"
import script from "./editTabulations.vue?vue&type=script&lang=js"
export * from "./editTabulations.vue?vue&type=script&lang=js"
import style0 from "./editTabulations.vue?vue&type=style&index=0&id=639cb7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639cb7b0",
  null
  
)

export default component.exports